import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auction-status-block"
}
const _hoisted_2 = { class: "auction-status-wrapper" }
const _hoisted_3 = ["innerHTML"]

import { computed, inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
  import CustomScrollbar from "@/components/_partials/CustomScrollbar.vue";
  import { useAuctionStore } from "@/stores/AuctionStore";
  import simplebar from "simplebar-vue";
  import { BaseIcon, KeepIcon } from "@/components/icons";
  import { IMessage } from "@/models";
  import { LogTypes, AuctionStatuses, LotStatuses } from "@/enum";
  import PinnedMessage from "@/components/_partials/PinnedMessage.vue";
  import { trans } from "@/utils/trans";
  import { isScreenL } from "@/utils/media-size";
  import { isPageVisible } from "@/utils/page-visibility";
  import TimerLiveAuctionBegin from "@/components/_partials/TimerLiveAuctionBegin.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'History',
  props: {
    disableMobileTeleport: { type: Boolean, default: false }
  },
  setup(__props: any) {

  const props = __props;

  const emitter = inject("emitter");
  const auctionStore = useAuctionStore();
  const container = ref<typeof simplebar>();
  const newMessage = ref<IMessage | null>(null);
  const resetPinedMessageTimerId = ref<number | null>(null);
  const historyLogs = computed(() => auctionStore.historyLogs);
  const auctionStatus = computed(() => auctionStore.auction.status);
  const user = computed(() => auctionStore.user);
  const activeLotId = computed(() => auctionStore.activeLot?.id ?? auctionStore.fakeActiveLot?.id ?? null);
  const liveLotId = computed(() => auctionStore.lots.find((item) => item.status === LotStatuses.LIVE)?.id ?? null);
  const hasMobileHistoryTarget = ref(false);
  let mobileHistoryTargetObserver: MutationObserver | null = null;

  const syncMobileHistoryTarget = () => {
    hasMobileHistoryTarget.value = !!document.querySelector("#history-mobile-wrapper .lot-timeline-messages");
  };

  watch(
    () => [isScreenL.value, activeLotId.value, liveLotId.value, auctionStatus.value],
    async () => {
      await nextTick();
      syncMobileHistoryTarget();
    },
    { immediate: true }
  );

  watch(
    () => historyLogs.value.length,
    async () => {
      await nextTick();
      syncMobileHistoryTarget();
    }
  );

  watch(
    historyLogs,
    () => {
      setTimeout(() => {
        const messages = document.querySelectorAll(".event-message.js-secondary");
        messages.forEach((message) => {
          message.classList.add("secondary");
        });
      }, 100);
      setTimeout(() => {
        const messages = document.querySelectorAll(".event-message.js-secondary");
        messages.forEach((message) => {
          message.classList.remove("secondary", "js-secondary");
        });
      }, 1500);
      nextTick(() => {
        if (container.value) {
          container.value.scrollTop = container.value.scrollHeight;
        }
      });
    },
    { deep: true }
  );

  // watch(activeLot, () => {
  //   refreshLogs();
  // });
  //
  // onMounted(() => {
  //   refreshLogs();
  // });
  //
  // const refreshLogs = () => {
  //   console.log("refreshLogs");
  //   auctionStore.resetHistoryLog();
  //
  //   if (activeLot.value) {
  //     console.log("activeLot.value.logs", activeLot.value.logs);
  //     activeLot.value.logs.forEach((item) => {
  //       auctionStore.addHistoryLog(item);
  //     });
  //   }
  // };

  onMounted(() => {
    nextTick(() => {
      syncMobileHistoryTarget();
      mobileHistoryTargetObserver = new MutationObserver(() => {
        syncMobileHistoryTarget();
      });
      mobileHistoryTargetObserver.observe(document.body, { childList: true, subtree: true });
      if (isScreenL.value && container.value) {
        container.value.scrollTop = container.value.scrollHeight;
      }
    });
  });

  onBeforeUnmount(() => {
    mobileHistoryTargetObserver?.disconnect();
  });

  const onInitScroll = (scrollbar: typeof simplebar) => {
    container.value = scrollbar.value.scrollElement;
  };

  emitter?.on("on:chat-new-message", (message: IMessage) => {
    newMessage.value = message;

    if (resetPinedMessageTimerId.value) {
      clearTimeout(resetPinedMessageTimerId.value);
    }

    resetPinedMessageTimerId.value = setTimeout(() => {
      newMessage.value = null;
    }, (auctionStore.newMessagePinSeconds || 60) * 1000);
  });

return (_ctx: any,_cache: any) => {
  return (!_unref(auctionStore).user?.is_admin && auctionStatus.value === _unref(AuctionStatuses).ACTIVE)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(TimerLiveAuctionBegin)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(['lot-timeline-messages', { 'pinned-message': _unref(auctionStore).pinMessage?.id }])
      }, [
        (_openBlock(), _createBlock(_Teleport, {
          disabled: props.disableMobileTeleport || !_unref(isScreenL) || !hasMobileHistoryTarget.value,
          to: "#history-mobile-wrapper .lot-timeline-messages",
          defer: ""
        }, [
          _createVNode(CustomScrollbar, {
            class: _normalizeClass(["custom-scrollbar controller-scrollbar", { 'not-scroller': historyLogs.value?.length < 4 }]),
            onScrollerComponent: onInitScroll
          }, {
            default: _withCtx(() => [
              _createVNode(PinnedMessage, {
                hidden: user.value?.is_admin || _unref(isScreenL)
              }, null, 8, ["hidden"]),
              _createVNode(_TransitionGroup, {
                name: "history-messages",
                css: _unref(isPageVisible)
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(historyLogs.value, (log) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([
            'event-message',
            {
              'js-secondary': log.is_recent,
              'your-bid': log.is_your_bid,
              clarified: log.type === _unref(LogTypes).AUTO_BID,
              primary: log.type === _unref(LogTypes).SOLD || log.type === _unref(LogTypes).UNSOLD
            }
          ]),
                      key: log.id,
                      innerHTML: log.text
                    }, null, 10, _hoisted_3))
                  }), 128))
                ]),
                _: 1
              }, 8, ["css"])
            ]),
            _: 1
          }, 8, ["class"])
        ], 8, ["disabled"]))
      ], 2))
}
}

})